import { render, staticRenderFns } from "./Pesquisa.vue?vue&type=template&id=e02a0a10"
import script from "./Pesquisa.vue?vue&type=script&lang=js"
export * from "./Pesquisa.vue?vue&type=script&lang=js"
import style0 from "./Pesquisa.vue?vue&type=style&index=0&id=e02a0a10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports